var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 14,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.546 2.115a.997.997 0 1 0-1.41-1.41L7.25 5.59 2.366.705a.997.997 0 1 0-1.41 1.41L5.84 7 .956 11.885a.997.997 0 0 0 1.41 1.41L7.25 8.41l4.885 4.885a.997.997 0 1 0 1.41-1.41L8.66 7l4.885-4.885Z",
  fill: "#393939"
})));
export default SvgIcClose;